import {
  Divider,
  Heading,
  HStack,
  useBreakpointValue,
  Text,
  StackProps,
} from '@chakra-ui/react';
import { ReactNode } from 'react';
import { SvgInfo } from 'src/components/icons';

export interface EditorHeaderProps {
  heading: ReactNode | string;
  children?: ReactNode;
  saved?: boolean;
}

export function EditorHeader({
  children,
  heading,
  saved,
  ...props
}: EditorHeaderProps & StackProps) {
  const headingStyle = useBreakpointValue({ base: 'h3', md: 'h2' });

  return (
    <>
      <HStack justifyContent="space-between" spacing={[0, 5]} {...props}>
        {typeof heading === 'string' ? (
          <HStack spacing={3}>
            <Heading textStyle={headingStyle}>{heading}</Heading>
            {saved && (
              <HStack>
                <Text textStyle="body0">Saved</Text>
                <SvgInfo color="#DADADA" fontSize="16px" />
              </HStack>
            )}
          </HStack>
        ) : (
          heading || ''
        )}
        <HStack
          position={['fixed', 'relative']}
          bg={['white', 'unset']}
          py={['24px', 0]}
          zIndex={[9, 0]}
          bottom={0}
          left={0}
          right={0}
          justifyContent="center"
          boxShadow={['0px -3px 6px rgba(0, 0, 0, 0.05)', 'none']}
        >
          {children}
        </HStack>
      </HStack>
      <Divider width="auto" my={5} px={props.px} />
    </>
  );
}
